import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
    AppBlockPort,
    AppBlockLinkParameter,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';

export default class VariableUpdatedNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Variable Updated';
        this.id = 'node_variable_updated';
        this.linkedFeature = 'general';

        this.outputs = [
            {
                name: 'Updated',
                portId: 'variable_updated',
                params: [] as AppBlockLinkParameter[],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'VARIABLE',
                name: 'Variable',
                settingType: SettingType.OPTION,
                refId: 'variable',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const project: ProjectConfiguration = this.project;
            const VARIABLE = project.getFeature(this.getSettingValue('VARIABLE'));
            if (VARIABLE) {
                return ` ${VARIABLE.getSettingValue('VARNAME')} updated`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const value = super.getSettingValue('DISPLAY_NAME');
        if (value !== '') {
            return value;
        }
        const project: ProjectConfiguration = this.project;
        const VARIABLE = project.getFeature(this.getSettingValue('VARIABLE'));
        if (VARIABLE) {
            return ` ${VARIABLE.getSettingValue('VARNAME')} updated`;
        }
        return '';
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const FEATURE = project.getFeature(this.getSettingValue('VARIABLE'));
        const DEBUGPRINT = this.getSettingValue('DEBUGPRINT') === '1';
        if (FEATURE) {
            const VARNAME = FEATURE.getSettingValue('VARNAME');

            const links = project.getNodeLinks(this, 'variable_updated');
            if (links.length > 0) {
                const link = links[0];
                blocks.push({
                    location: `var_${VARNAME}_updated`,
                    blockType: BlockType.CODE,
                    id: this.getID(),
                    template: `'****${link.getSourceId()}****'`,
                });
            }
        }

        return blocks;
    }

    getDetails(): string {
        return `
##### On Variable Updated
This block is triggered when the selected variable's value is updated — even if it hasn't _changed_.

For example, a variable holding the latest value from a temperature sensor will be updated regularly. Even if the temperature remains constant, this block will be triggered by each update.`;
    }
}
